<template>
    <ies-form-field :field="field">
        <v-row no-gutters>
            <v-col cols="1" class="checkbox">
                <input
                    type="checkbox"
                    v-model="isBookingRestricted"
                    :disabled="field.disabled"
                >
            </v-col>

            <v-col v-if="isBookingRestricted" cols="12" class="pl-2" style="max-width: 320px;">
                <v-select
                    v-model="bookingPeriodType"
                    :items="bookingPeriodTypeOptions"
                    outlined
                    dense
                    hide-details
                    :disabled="field.disabled"
                ></v-select>
            </v-col>

        <v-col cols="12" v-if="isBookingRestricted">
            <ies-date-range-rows
                v-if="bookingPeriodType === 'dateRange'"
                :date-ranges="dateRanges"
                :disabled="field.disabled"
            ></ies-date-range-rows>

            <div v-if="bookingPeriodType === 'lastMinute'" style="display: flex; align-items: center;" class="mt-2">
                <span class="mr-2">Less than</span>
                <v-text-field
                    v-model.number="days"
                    type="number"
                    min="0"
                    style="max-width: 80px;"
                    outlined
                    dense
                    hide-details
                    :disabled="field.disabled"
                ></v-text-field>
                <span class="ml-2">days prior to arrival date</span>
            </div>

            <div v-if="bookingPeriodType === 'earlyBird'" style="display: flex; align-items: center;" class="mt-2">
                <span class="mr-2">More than</span>
                <v-text-field
                    v-model.number="days"
                    type="number"
                    min="0"
                    style="max-width: 80px;"
                    outlined
                    dense
                    hide-details
                    :disabled="field.disabled"
                ></v-text-field>
                <span class="ml-2">days prior to arrival date</span>
            </div>
        </v-col>
        </v-row>
    </ies-form-field>
</template>

<script>
var dateRangeRowsModule = require('./DateRangeRows.vue');
var newDateRange = dateRangeRowsModule.newDateRange;

export default {
    name: 'ies-input-is-booking-restricted',
    props: ['field', 'page'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
        'ies-date-range-rows': dateRangeRowsModule.default,
    },
    data () {
        return {
            isBookingRestricted: false,
            bookingPeriodType: 'dateRange',
            dateRanges: [],
            days: null,
            bookingPeriodTypeOptions: [
                { text: 'Booked within range', value: 'dateRange' },
                { text: 'Last Minute Rate', value: 'lastMinute' },
                { text: 'Early Bird Rate', value: 'earlyBird' },
            ],
            rateTypeKey: null,
            loading: false,
        };
    },
    methods: {
        initFromFieldValue: function () {
            var existingValue = this.field.value || this.field.oldValue;

            if (existingValue && typeof existingValue === 'object') {
                this.isBookingRestricted = !!existingValue.isBookingRestricted;
                this.bookingPeriodType = existingValue.bookingPeriodType || 'dateRange';
                this.days = existingValue.days || null;

                if (Array.isArray(existingValue.dateRanges)) {
                    this.dateRanges = existingValue.dateRanges.map(function (dateRange) {
                        return {
                            from: dateRange.from || '',
                            to: dateRange.to || '',
                            fromMenuOpen: false,
                            toMenuOpen: false,
                        };
                    });
                }
            } else {
                this.isBookingRestricted = parseInt(existingValue) === 1;
            }

            if (this.isBookingRestricted && this.bookingPeriodType === 'dateRange' && this.dateRanges.length === 0) {
                this.dateRanges.push(newDateRange());
            }
        },

        setRateKeyFromUrl: function () {
            if (!this.page || !this.page.edit_url) {
                return;
            }

            let bits = this.page.edit_url.split('/');
            let urlBits = location.pathname.split('/').splice(1);

            bits.forEach(function (bit, index) {
                if (bit === '{RateType.rate_type_key}') {
                    this.rateTypeKey = parseInt(urlBits[index]);
                }
            }.bind(this));
        },

        modeToType: function (mode) {
            if (mode === 2) return 'lastMinute';
            if (mode === 3) return 'earlyBird';
            return 'dateRange';
        },

        loadExistingState: function () {
            this.loading = true;

            axios.get('/api/rate-type-booking-restricted/' + this.rateTypeKey).then(function (response) {
                var data = response.data;
                var type = this.modeToType(data.bookingRestrictedMode);

                this.bookingPeriodType = type;

                if (type === 'lastMinute') {
                    this.days = data.bookingRestrictedDaysLess || null;
                } else if (type === 'earlyBird') {
                    this.days = data.bookingRestrictedDaysMore || null;
                } else {
                    var loaded = data.dateRanges.map(function (dateRange) {
                        return {
                            from: dateRange.from || '',
                            to: dateRange.to || '',
                            fromMenuOpen: false,
                            toMenuOpen: false,
                        };
                    });
                    this.dateRanges = loaded.length > 0 ? loaded : [newDateRange()];
                }
            }.bind(this)).finally(function () {
                this.loading = false;
            }.bind(this));
        },
    },
    computed: {
        submissionData: function () {
            return {
                rateTypeKey: this.rateTypeKey,
                isBookingRestricted: this.isBookingRestricted,
                bookingPeriodType: this.bookingPeriodType,
                dateRanges: this.dateRanges.map(function (dateRange) {
                    return {
                        from: dateRange.from,
                        to: dateRange.to,
                    };
                }),
                days: this.days,
            };
        },
    },
    watch: {
        submissionData: {
            deep: true,
            handler: function (value) {
                this.field.value = value;
            },
        },

        isBookingRestricted: function (value) {
            if (value && this.bookingPeriodType === 'dateRange' && this.dateRanges.length === 0) {
                this.dateRanges.push(newDateRange());
            }
        },

        bookingPeriodType: function (value) {
            if (value === 'dateRange' && this.dateRanges.length === 0) {
                this.dateRanges.push(newDateRange());
            }
        },
    },
    created: function () {
        this.initFromFieldValue();
        this.setRateKeyFromUrl();
        this.field.value = this.submissionData;

        if (this.isBookingRestricted && this.rateTypeKey) {
            this.loadExistingState();
        }
    },
};
</script>
